import axios, { AxiosRequestConfig } from "axios";
import { store } from "./../Store/Store";
import * as ErrorActions from "./../Store/Actions/ErrorActions";
import * as UserActions from "./../Store/Actions/UserActions";
import * as ViewManagementActions from "./../Store/Actions/ViewManagementActions";
import { RootState } from "src/Store/Reducers/_RootReducer";

export type QueryParams = {
  key: any;
  value: any;
};

// PROD:
export const baseURL = process.env.REACT_APP_BASE_URL;
export const domainURL = process.env.REACT_APP_DOMAIN_URL;
// TEST:
// export const baseURL = "//obligain.k-org.pl/api/public_ht";
// export const domainURL = process.env.REACT_APP_DOMAIN_URL;

export let activeToken = (store.getState() as RootState).userStore.token ? store.getState().userStore.token : localStorage.getItem("token");

const axiosInstance = axios.create({
  // PROD:
  // baseURL: `https:${baseURL}`
  // TEST:
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.defaults.headers.post["Content-Type"] = "application/json";

function handleConfigInterCeptor(configRq: AxiosRequestConfig) {
  store.dispatch(ErrorActions.clearErrorStore());
  store.dispatch(ErrorActions.setRequestConfig(configRq));
  return configRq;
}

function handleInterceptorError(error: any) {
  const { response, config: CFG } = error;
  console.log("BŁAD", `${CFG.url}`);
  console.log("BŁAD", `${CFG.baseURL}/logout`);
  if (response && response.status === 401 && CFG.url !== `${CFG.baseURL}/login` && CFG.url !== `${CFG.baseURL}/logout`) {
    store.dispatch(UserActions.logoutUser());
  }
  if (response) {
    store.dispatch(ErrorActions.setResponseError(response ? response : error));
  } else {
    store.dispatch(ErrorActions.setResponseError(response ? response : error, true));
  }
  store.dispatch(ViewManagementActions.hideLoader());
  return Promise.reject(error);
}

axiosInstance.interceptors.request.use(
  (configRq: AxiosRequestConfig) => {
    if (localStorage.getItem("token")) {
      configRq.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    }
    // return config;
    return handleConfigInterCeptor(configRq);
  },

  (error) => handleInterceptorError(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch(ErrorActions.requestSuccess(response));
    return response;
  },
  (error) => handleInterceptorError(error)
);

export const config = (params?: any, headers?: any, responseType?: any) => {
  const configRq: AxiosRequestConfig = {};
  if (params) {
    configRq.params = params;
  }
  if (headers) {
    configRq.headers = headers;
  }
  if (responseType) {
    configRq.responseType = responseType;
  }
  return configRq;
};

export function createSerachQuery(params: Object | Array<Object>): URLSearchParams {
  const searchQuery = new URLSearchParams();
  Object.keys(params).forEach((e, i) => {
    if (e === "risk" || e === "interest" || e === "duration") {
      searchQuery.set(`min-${e}`, params[e]["min"]);
      searchQuery.set(`max-${e}`, params[e]["max"]);
    } else {
      searchQuery.set(e, params[e]);
    }
  });
  return searchQuery;
}

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/Connectors/config.ts